"use strict";

class StationSettingsMasterCtrl {

    constructor($rootScope, $http, $scope, $mdToast)
    {
        this.$rootScope = $rootScope;

        this.$http = $http;
        this.$mdToast = $mdToast;

        this.stations = [];

        this.stationKey = null;
        this.stationSecret = null;

        this.fetch();

        this.$rootScope.saveHiden = true;
    }

    fetch()
    {
        this.$http.get('/station').then(response => {
            this.stationKey = response.data.station_key;
            this.stationSecret = "●●●●●●●●●●●●●●●";
        });

        this.$http.get('/station/slavestations').then(response => {
            this.stations = response.data;
        });
    }

    generateStationSecret()
    {
        this.$http.get('/station/generatestationsecret').then(response => {
            this.stationSecret = response.data;
        });
    }

    deleteStation(key)
    {
        this.$http.post('/station/removeslavestation/' + key).then(response => {
            this.fetch();
        });
    }
}

StationSettingsMasterCtrl.$inject = [
    '$rootScope',
    '$http',
    '$scope',
    '$mdToast'
];

module.exports = StationSettingsMasterCtrl;